(function () {
  const MAX_FILES = 10;
  const MAX_FILE_SIZE = 20 * 1024 * 1024;
  const ACCEPTED_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.heic', '.pdf', '.doc', '.docx'];
  const ACCEPTED_MIME_PREFIXES = ['image/'];
  const ACCEPTED_MIME_TYPES = [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  ];

  const form = document.getElementById('ContactForm');
  if (!form) return;

  const container = form.closest('[data-upload-variant-id]');
  const variantId = container?.dataset.uploadVariantId?.trim();
  const fileInput = document.getElementById('ContactForm-documents-input');
  const fileTrigger = form.querySelector('.contact-form-2__file-trigger');
  const fileList = document.getElementById('ContactForm-file-list');
  const documentsField = document.getElementById('ContactForm-documents');
  const errorEl = form.querySelector('.contact-form-2__file-error');
  const submitButton = form.querySelector('[type="submit"]');

  if (!fileInput || !fileList || !documentsField) return;

  /** @type {{ file: File, url: string|null, status: 'pending'|'uploading'|'done'|'error' }[]} */
  let entries = [];
  let isSubmitting = false;
  let allowNativeSubmit = false;

  function showError(message) {
    if (!errorEl) return;
    if (message) {
      errorEl.textContent = message;
      errorEl.classList.remove('hidden');
    } else {
      errorEl.textContent = '';
      errorEl.classList.add('hidden');
    }
  }

  function isAcceptedFile(file) {
    const extension = '.' + file.name.split('.').pop().toLowerCase();
    if (ACCEPTED_EXTENSIONS.includes(extension)) return true;
    if (ACCEPTED_MIME_PREFIXES.some((prefix) => file.type.startsWith(prefix))) return true;
    return ACCEPTED_MIME_TYPES.includes(file.type);
  }

  function getUploadedUrls() {
    return entries.filter((entry) => entry.status === 'done' && entry.url).map((entry) => entry.url);
  }

  function syncDocumentsField() {
    const urls = getUploadedUrls();
    documentsField.value = urls.map((url, index) => `${index + 1}. ${url}`).join('\n');
  }

  function renderFileList() {
    fileList.innerHTML = '';

    entries.forEach((entry, index) => {
      const item = document.createElement('li');
      item.className = 'contact-form-2__file-item';

      const name = document.createElement('span');
      name.className = 'contact-form-2__file-name';
      if (entry.status === 'uploading') {
        name.textContent = `${entry.file.name} (učitavanje…)`;
      } else if (entry.status === 'error') {
        name.textContent = `${entry.file.name} (greška)`;
      } else if (entry.status === 'done') {
        name.textContent = `${entry.file.name} ✓`;
      } else {
        name.textContent = entry.file.name;
      }

      const removeButton = document.createElement('button');
      removeButton.type = 'button';
      removeButton.className = 'contact-form-2__file-remove link';
      removeButton.textContent = 'Ukloni';
      removeButton.disabled = entry.status === 'uploading';
      removeButton.addEventListener('click', () => {
        entries = entries.filter((_, fileIndex) => fileIndex !== index);
        syncDocumentsField();
        renderFileList();
        showError('');
      });

      item.append(name, removeButton);
      fileList.appendChild(item);
    });

    if (fileTrigger) {
      fileTrigger.disabled = entries.length >= MAX_FILES || entries.some((entry) => entry.status === 'uploading');
    }
  }

  async function parseJsonResponse(response) {
    try {
      return await response.json();
    } catch (error) {
      throw new Error('Učitavanje datoteka nije uspjelo. Pokušajte ponovno.');
    }
  }

  function extractUploadUrls(properties) {
    return Object.values(properties || {}).filter((value) => {
      if (typeof value !== 'string' || !value) return false;
      return value.includes('/uploads/') || value.includes('cdn.shopify.com');
    });
  }

  async function uploadEntry(entry) {
    if (!variantId) {
      throw new Error('Učitavanje dokumenata trenutno nije dostupno. Molimo kontaktirajte nas putem e-maila.');
    }

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    formData.append('properties[Dokument]', entry.file);

    const cartAddUrl = window.routes?.cart_add_url || '/cart/add';
    const response = await fetch(cartAddUrl, {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/javascript',
      },
      body: formData,
    });

    const data = await parseJsonResponse(response);

    if (data.status) {
      throw new Error(data.description || 'Učitavanje datoteka nije uspjelo.');
    }

    const item = data.items?.[0] || data;
    const urls = extractUploadUrls(item.properties);

    if (!urls.length) {
      throw new Error('Učitavanje datoteka nije uspjelo.');
    }

    if (item.key) {
      try {
        await fetch(window.routes?.cart_change_url || '/cart/change', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ id: item.key, quantity: 0 }),
        });
      } catch (error) {
        // Link is already on CDN; cart cleanup is best-effort.
      }
    }

    return urls[0];
  }

  async function uploadPendingEntries() {
    const pending = entries.filter((entry) => entry.status === 'pending' || entry.status === 'error');

    for (const entry of pending) {
      entry.status = 'uploading';
      entry.url = null;
      renderFileList();

      try {
        entry.url = await uploadEntry(entry);
        entry.status = 'done';
      } catch (error) {
        entry.status = 'error';
        syncDocumentsField();
        renderFileList();
        throw error;
      }

      syncDocumentsField();
      renderFileList();
    }
  }

  function addFiles(files) {
    const validFiles = [];

    for (const file of files) {
      if (entries.length + validFiles.length >= MAX_FILES) {
        showError(`Možete učitati najviše ${MAX_FILES} datoteka odjednom.`);
        break;
      }

      if (!isAcceptedFile(file)) {
        showError('Podržani formati: slike, PDF i Word dokumenti.');
        continue;
      }

      if (file.size > MAX_FILE_SIZE) {
        showError('Svaka datoteka može biti najviše 20 MB.');
        continue;
      }

      validFiles.push(file);
    }

    if (!validFiles.length) return;

    validFiles.forEach((file) => {
      entries.push({ file, url: null, status: 'pending' });
    });

    renderFileList();
    showError('');

    uploadPendingEntries().catch((error) => {
      showError(error.message || 'Učitavanje datoteka nije uspjelo. Pokušajte ponovno.');
    });
  }

  fileTrigger?.addEventListener('click', () => fileInput.click());

  fileInput.addEventListener('change', () => {
    if (!fileInput.files?.length) return;
    addFiles(Array.from(fileInput.files));
    fileInput.value = '';
  });

  form.addEventListener('submit', async (event) => {
    // Native re-submit after deferred upload — must not preventDefault or CAPTCHA breaks.
    if (allowNativeSubmit) {
      allowNativeSubmit = false;
      return;
    }

    if (!entries.length) return;

    // Files already on CDN: only sync hidden fields and let the browser submit
    // normally so Shopify can attach the CAPTCHA token.
    const allDone =
      entries.every((entry) => entry.status === 'done') && getUploadedUrls().length > 0;

    if (allDone) {
      syncDocumentsField();
      return;
    }

    const hasPending = entries.some(
      (entry) => entry.status === 'pending' || entry.status === 'uploading' || entry.status === 'error'
    );

    if (!hasPending && getUploadedUrls().length === 0) {
      showError('Učitavanje datoteka nije uspjelo. Pokušajte ponovno.');
      event.preventDefault();
      return;
    }

    event.preventDefault();

    if (isSubmitting) return;

    showError('');
    isSubmitting = true;

    const originalLabel = submitButton?.textContent;

    if (submitButton) {
      submitButton.setAttribute('aria-disabled', 'true');
      submitButton.disabled = true;
      submitButton.textContent = 'Učitavanje...';
    }

    try {
      await uploadPendingEntries();

      const failed = entries.some((entry) => entry.status === 'error' || entry.status !== 'done');
      if (failed || !getUploadedUrls().length) {
        throw new Error('Učitavanje datoteka nije uspjelo. Pokušajte ponovno.');
      }

      syncDocumentsField();

      if (!documentsField.value.trim()) {
        throw new Error('Učitavanje datoteka nije uspjelo. Pokušajte ponovno.');
      }

      if (submitButton) {
        submitButton.removeAttribute('aria-disabled');
        submitButton.disabled = false;
        submitButton.textContent = originalLabel;
      }

      isSubmitting = false;
      allowNativeSubmit = true;

      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit(submitButton || undefined);
      } else {
        submitButton?.click();
      }
    } catch (error) {
      showError(error.message || 'Učitavanje datoteka nije uspjelo. Pokušajte ponovno.');
      isSubmitting = false;
      allowNativeSubmit = false;

      if (submitButton) {
        submitButton.removeAttribute('aria-disabled');
        submitButton.disabled = false;
        submitButton.textContent = originalLabel;
      }
    }
  });
})();
